export const painManagementText = `The Treat the Pain program is designed to improve access to essential pain medicines. More than 3.2 billion
          people worldwide lack access to adequate pain relief even though morphine, the most effective treatment for
          severe pain, is safe, effective, plentiful, inexpensive, and easy-to-use. The program provides technical
          support to improve patient access to opioid analgesics, with a focus on low and middle-income countries with
          high unmet need for pain relief.`
